const BASE_URL = 'https://m4ore.com'

const LANG_MAP = {
  tw: 'zh-Hant-TW',
  en: 'en',
  jp: 'ja'
}

const HREFLANG_ENTRIES = [
  { hreflang: 'zh-Hant-TW', lang: 'tw' },
  { hreflang: 'en', lang: 'en' },
  { hreflang: 'ja', lang: 'jp' },
  { hreflang: 'x-default', lang: null }
]

function setMetaTag(attr, attrValue, content) {
  let el = document.querySelector(`meta[${attr}="${attrValue}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, attrValue)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function setCanonical(url) {
  let el = document.querySelector('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', url)
}

function updateHreflang(path) {
  document.querySelectorAll('link[hreflang]').forEach(el => el.remove())

  HREFLANG_ENTRIES.forEach(({ hreflang, lang }) => {
    const link = document.createElement('link')
    link.setAttribute('rel', 'alternate')
    link.setAttribute('hreflang', hreflang)
    const href = lang ? `${BASE_URL}${path}?lang=${lang}` : `${BASE_URL}${path}`
    link.setAttribute('href', href)
    document.head.appendChild(link)
  })
}

export function updateMeta(route, lang) {
  const meta = route.meta || {}
  const langKey = lang || 'tw'
  const titles = meta.title || {}
  const descriptions = meta.description || {}

  const title = titles[langKey] || titles.tw || 'MOOOORE CO., LTD.'
  const description = descriptions[langKey] || descriptions.tw || ''

  document.title = title
  document.documentElement.lang = LANG_MAP[langKey] || 'zh-Hant-TW'

  const path = route.path || '/'
  const canonicalUrl = `${BASE_URL}${path}`

  setMetaTag('name', 'description', description)
  setMetaTag('property', 'og:title', title)
  setMetaTag('property', 'og:description', description)
  setMetaTag('property', 'og:url', canonicalUrl)
  setMetaTag('name', 'twitter:title', title)
  setMetaTag('name', 'twitter:description', description)
  setCanonical(canonicalUrl)
  updateHreflang(path)
}
